import {
  AssignClientsToUserPayloadType,
  ChangePasswordPayloadType,
  GetAssignedClientsToUserPayloadType,
  ChangeFinacUserPasswordType,
  LoginPayloadType,
  UserPayLoadType,
  ChangeFinacUserFirstLastNameType,
  ChangeUserStatusType,
  GetAllClientsListPayloadType,
  ResetForgetPasswordPayloadType,
  LoginWithMobileNumberPayloadType,
  LoginWithMobileOtpVerifyPayloadType,
  GetAllFinacUserPayloadType,
  GetAllUserOfSingleClientListPayloadType,
  getIndividualClientsPayload,
  AddRemoveFromFavouritePayloadType,
  UnassignedUserOfSingleClient,
  CheckUniquiEmailAndMobilePayloadType,
  AddAttendanceTimePayloadType,
  GetAttendanceTimePayloadType,
  GetUserProfilePayload,
  GetCountryListSignUpDataPayloadType,
  GetCityListSignUpDataPayloadType,
  GetStateListSignUpDataPayloadType,
  SignUpUserPayloadType,
  GetTeamDirectoryPayloadType,
  GetSignUpOtpPayloadType,
  SignUpOtpVerifyPayloadType,
  GetGovtOfficerJobListPayloadType,
  GetAccountNoPaymentVoucherPayloadType,
} from "../commonTypes/authTypes";
import { getData, postData } from "./apiInstance";
import { AxiosResponse } from "axios";
import { UserProfileType } from "../redux/auth/authTypes";
import { convertPasswordToHash, getCSRFToken } from "../utils/commonFunctions";
import { countryCode } from "../constant/countryCode";

export async function loginUserApi(
  data: LoginPayloadType
): Promise<AxiosResponse> {
  return await postData(`user/login`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export async function loginWithMobileNumberApi(
  data: LoginWithMobileNumberPayloadType
): Promise<AxiosResponse> {
  const finalData = {
    mobile_number: data?.mobileNumber,
    country_code: data?.countryCode,
  };
  return await postData(`user/login/mobile`, finalData, {
    headers: {
      "content-Type": "application/json",
    },
  });
}

export async function loginWithMobileOtpVerifyApi(
  data: LoginWithMobileOtpVerifyPayloadType
): Promise<AxiosResponse> {
  let csrfToken = localStorage.getItem("csrfToken");
  const finalData = {
    mobile_number: data?.mobileNumber,
    country_code: data?.countryCode,
    otp: data?.otp,
  };
  return await postData(`user/login/otp-verification`, finalData, {
    headers: {
      "content-Type": "application/json",
      "x-csrf-token": csrfToken,
    },
  });
}

export async function logoutUserApi(
  token: string | null
): Promise<AxiosResponse> {
  let csrfToken = localStorage.getItem("csrfToken");
  return await postData(
    `user/logout`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": csrfToken,
      },
    }
  );
}

export async function forgetPasswordApi(
  email: string | null
): Promise<AxiosResponse> {
  const finalData = {
    email_id: email,
  };
  return await postData(`user/forget-password/generatetoken`, finalData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export async function resetForgetPasswordApi(
  data: ResetForgetPasswordPayloadType
): Promise<AxiosResponse> {
  const finalData = {
    token: data?.token,
    reset_password: data?.newPassword,
    confirm_password: data?.confirmPassword,
  };
  return await postData(`user/reset-forget-password`, finalData, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export async function getUserProfileApi(token: string): Promise<AxiosResponse> {
  return await getData(`user/profile`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function userProfileApi(
  data: GetUserProfilePayload
): Promise<AxiosResponse> {
  const { token, user_id } = data;
  let finalParams = {
    ...(user_id && user_id > 0 && { user_id }),
  };
  return await getData(`finac/user/profile`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function updateProfileApi(data: any): Promise<AxiosResponse> {
  let { token, profileData, status } = data;

  return await postData(
    `finac/user/profile/update`,
    { ...profileData, status },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function addUserApi(data: any): Promise<AxiosResponse> {
  let { token, profileData } = data;

  return await postData(
    `finac/user/add`,
    { ...profileData },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function checkUniqueEmailAndMobileNoApi(
  data: CheckUniquiEmailAndMobilePayloadType
): Promise<AxiosResponse> {
  const { token, operation, email, mobile, user_id } = data;
  const finalParams = {
    operation,
    email,
    mobile,
    user_id,
  };

  return await getData(`check/unique/email-mobile`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function checkRecruitmentTrackerUniqueEmailAndMobileNoApi(
  data: CheckUniquiEmailAndMobilePayloadType
): Promise<AxiosResponse> {
  const { token, operation, value, check_name, id } = data;
  const finalParams = {
    operation,
    value,
    check_name,
    id,
  };

  return await getData(
    `finac-crm/hrms/recruitment-application/unique-check/email/number`,
    {
      params: {
        ...finalParams,
      },
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}

export async function updatePasswordApi(
  data: ChangePasswordPayloadType
): Promise<AxiosResponse> {
  const { currentPassword, confirmPassword, resetPassword, token } = data;
  let finalData = {
    current_password: currentPassword,
    reset_password: resetPassword,
    confirm_password: confirmPassword,
  };

  return await postData(`user/reset-password`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

////api closed... Do not used this
export async function getAllClientsApi(
  data: GetAllClientsListPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, status, search_term } = data;

  let finalParams = {
    limit,
    offset,
    ...(search_term && search_term?.length > 0 && { search_term }),
  };

  return await getData(`client/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllUserOfSingleClientApi(
  data: GetAllUserOfSingleClientListPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, status, client_code, search_term, user_type } =
    data;

  let finalParams = {
    limit,
    offset,
    status,
    client_code,
    user_type,
    ...(search_term && search_term?.length > 0 && { search_term }),
  };

  return await getData(`client/access/user-list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function unassignedUserOfClient(
  data: UnassignedUserOfSingleClient
): Promise<AxiosResponse> {
  const { token, clientId, userId } = data;
  const finalData = {
    client_code: clientId,
    user_id: userId,
  };
  return await postData(`client/user/unassign`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getAllUsersApi(
  data: UserPayLoadType
): Promise<AxiosResponse> {
  const { token, limit, offset, status, user_type, search_term } = data;

  let finalParams = {
    user_type,
    limit,
    offset,
    status,
    ...(search_term && search_term?.length > 0 && { search_term }),
  };

  return await getData(`user/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getIndividualClientsApi(
  data: getIndividualClientsPayload
): Promise<AxiosResponse> {
  const { client_code, name, srch_value, token } = data;
  return await getData(`client/individual/list`, {
    params: {
      client_code,
      name,
      search_term: srch_value,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function assignClientsToUserApi(
  data: AssignClientsToUserPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, user_id, user_type } = data;
  let finalData = {
    user_id,
    client_code,
    user_type,
  };

  return await postData(`client/user/mapping`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getAssignedClientsToUserApi(
  data: GetAssignedClientsToUserPayloadType
): Promise<AxiosResponse> {
  if (data.hasOwnProperty("user_id")) {
    const { user_id, token, name, client_code, srch_value, limit, offset } =
      data;
    return await getData(`client/user/mapping/list`, {
      params: {
        user_id,
        name,
        client_code,
        search_term: srch_value,
        limit,
        offset,
      },
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    });
  } else {
    const { user_id, token, name, client_code, srch_value, limit, offset } =
      data;
    return await getData(`client/user/mapping/list`, {
      params: {
        user_id,
        name_sorted_order: name,
        client_code_sorted_order: client_code,
        search_term: srch_value,
        limit,
        offset,
      },
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    });
  }
}

export async function getAllFinacUsersApi(
  data: GetAllFinacUserPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    offset,
    limit,
    search_term,
    user_type,
    client_code,
    status,
    department,
    employment_status,
    sortBy,
    sortingOrder,
  } = data;
  let finalParams = {
    limit,
    offset,
    status: status,
    client_code,
    user_type: user_type,
    department,
    employment_status,
    ...(search_term && search_term?.length > 0 && { search_term }),
    sorting_order: sortingOrder,
    sort_by: sortBy,
  };

  return await getData(`finac/user/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function changeFinacUserPasswordApi(
  data: ChangeFinacUserPasswordType
): Promise<AxiosResponse> {
  const { user_id, newPassword, confirmNewPassword, token } = data;
  let finalData = {
    user_id,
    new_password: newPassword,
    confirm_password: confirmNewPassword,
  };

  return await postData(`admin/user/change-password`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function changeFinacFirstLastNameApi(
  data: ChangeFinacUserFirstLastNameType
): Promise<AxiosResponse> {
  const { user_id, first_name, last_name, token } = data;
  let finalData = {
    user_id,
    first_name,
    last_name,
  };

  return await postData(`admin/user/update`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function changeUserStatusApi(
  data: ChangeUserStatusType
): Promise<AxiosResponse> {
  const { token, status, user_id } = data;

  return await postData(
    `change/user/status`,
    { status, user_id },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function addRemoveFromFavourite(
  data: AddRemoveFromFavouritePayloadType
): Promise<AxiosResponse> {
  const { token, client_code, is_fav_client } = data;

  return await postData(
    `client/user/fav`,
    { client_code, is_fav_client },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getAttendanceData(
  data: GetAttendanceTimePayloadType
): Promise<AxiosResponse> {
  const { token, date, user_id } = data;
  const params = {
    date,
    user_id,
  };
  return await getData(`master-module/attendence/list`, {
    params,
    headers: {
      "content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function addAttendanceTime(
  data: AddAttendanceTimePayloadType
): Promise<AxiosResponse> {
  const { token, date, startTime, id, endTime, location, latitude, longitude } =
    data;
  let finalData = {
    date,
    start_time: startTime,
    _id: id,
    end_time: endTime,
    location,
    latitude,
    longitude,
  };
  return await postData(`master-module/attendence/add`, finalData, {
    headers: {
      "content-type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function checkUniqueEmailAndMobileNoSignUpApi(
  data: CheckUniquiEmailAndMobilePayloadType
): Promise<AxiosResponse> {
  const { token, operation, email, mobile, user_id } = data;
  const finalParams = {
    operation,
    email,
    mobile,
    user_id,
  };
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await getData(`open-api/check/unique/email-mobile`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

export async function getAllCountrySignUpApi(
  data: GetCountryListSignUpDataPayloadType
): Promise<AxiosResponse> {
  const { offset, limit, search_term } = data;
  let finalParams = {
    limit,
    offset,
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await getData(`open-api/country`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

export async function getAllCitySignUpApi(
  data: GetCityListSignUpDataPayloadType
): Promise<AxiosResponse> {
  const { offset, limit, search_term, state_id, country_id } = data;
  let finalParams = {
    limit,
    offset,
    state_id,
    country_id,
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await getData(`/open-api/city`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

export async function getAllStateSignUpApi(
  data: GetStateListSignUpDataPayloadType
): Promise<AxiosResponse> {
  const { offset, limit, search_term, country_id } = data;
  let finalParams = {
    limit,
    offset,
    country_id,
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await getData(`/open-api/state`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

export async function signUpClientApi(data: any): Promise<AxiosResponse> {
  const { inputDetails } = data;

  let finalData = {
    channel_partner: inputDetails?.channel_partner,
    personal_details: {
      email: inputDetails?.passworDetails?.email,
      mobile_number: inputDetails?.mobileNumber,
    },
    business_details: {
      business_name: inputDetails?.businessInfo?.businessName?.trim(),
      entity_type: inputDetails?.businessInfo?.typeOfEntity?.value || "",
      number_of_employees:
        parseInt(inputDetails?.businessInfo?.noOfEmployee) || 0,
      business_address1: inputDetails?.businessInfo?.businessAddress?.trim(),
      business_address2: inputDetails?.businessInfo?.businessAddressTwo?.trim(),

      country: inputDetails?.businessInfo?.countryAddress,
      state: inputDetails?.businessInfo?.stateAddress,
      city: inputDetails?.businessInfo?.cityAddress,
      pincode: inputDetails?.businessInfo?.pincode,
    },

    client_signup_details: {
      voucher_code: inputDetails?.accountInfo?.voucherCode?.trim(),
      is_voucher_verified: inputDetails?.accountInfo?.isVoucherCodeVerified,
      // subscription_plan: inputDetails?.accountInfo?.selectedPlan
      subscription_plan:
        inputDetails?.accountInfo?.selectedPlan === "Basic Plan"
          ? "basic_plan"
          : inputDetails?.accountInfo?.selectedPlan === "Advanced Plan"
          ? "advanced_plan"
          : "",
      order_id:
        inputDetails?.accountInfo?.selectedPlan === "Basic Plan"
          ? ""
          : inputDetails?.orderId,
      product_id:
        inputDetails?.channel_partner === "au_bank"
          ? inputDetails?.accountInfo?.selectedPlan === "Basic Plan"
            ? 0
            : 1
          : 0,
      payment_details: inputDetails?.orderDetails,
      payment_amount:
        inputDetails?.accountInfo?.selectedPlan === "Advanced Plan"
          ? 999900
          : 0,
      is_payment_done: inputDetails?.isPaymentSuccessfull,
    },
    banking_details: {
      bank_name:
        inputDetails?.channel_partner === "au_bank" ? "AU Small Finance" : "",
      bank_account_number: inputDetails?.accountInfo?.accountNumber?.trim(),
      bank_account_name:
        inputDetails?.accountInfo?.auAccountNumberVerifyData?.name_at_bank?.trim(),
      is_bank_account_verified:
        inputDetails?.accountInfo?.isAuAccountNumberVerified,
      bank_verification_details:
        inputDetails?.accountInfo?.auAccountNumberVerifyData,
    },
    password: await convertPasswordToHash(
      inputDetails?.passworDetails?.password
    ),
    confirm_password: await convertPasswordToHash(
      inputDetails?.passworDetails?.newPassword
    ),
    is_signup_from_mobile: 0,
  };
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await postData(`client/user/signup`, finalData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

export async function getOtpSignUpApi(
  data: GetSignUpOtpPayloadType
): Promise<AxiosResponse> {
  const finalData = {
    mobile_number: data?.mobileNumber,
    country_code: data?.countryCode,
  };
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await postData(`send/signup/otp`, finalData, {
    headers: {
      "content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

export async function getSignUpStatusApi(
  data: GetAccountNoPaymentVoucherPayloadType
): Promise<AxiosResponse> {
  const finalParams = {
    mobile_number: data?.mobileNumber,
  };
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await getData(`/get/signup/status`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
  // return await postData(`/get/signup/status`, finalData, {
  //   headers: {
  //     "content-Type": "application/json",
  //     "Authorization": `Basic ${base64Credentials}`
  //   },
  // });
}

export async function signUpOtpVerifyApi(
  data: SignUpOtpVerifyPayloadType
): Promise<AxiosResponse> {
  let csrfToken = localStorage.getItem("csrfToken");
  const finalData = {
    mobile_number: data?.mobileNumber,
    country_code: data?.countryCode,
    otp: data?.otp,
  };
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await postData(`verify/signup/otp`, finalData, {
    headers: {
      "content-Type": "application/json",
      "x-csrf-token": csrfToken,
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

export async function getVerifyAuAccountNumberApi(
  data: any
): Promise<AxiosResponse> {
  const { ifsc_code, account_number, mobile_number } = data;
  let finalParams = {
    account_number,
    ifsc_code,
    mobile_number,
  };
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await getData(`/open-api/bank/verify/account/pennyless`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

// TEAM DIRECTORY
export async function getTeamDirectoryUserList(
  data: GetTeamDirectoryPayloadType
): Promise<AxiosResponse> {
  const { token, offset, limit, search_term, skill_filter, branch_filter } =
    data;
  let finalParams = {
    limit,
    offset,
    skill_filter,
    branch_filter,
    ...(search_term && search_term?.length > 0 && { search_term }),
  };

  return await getData(`finac-crm/team/directory/user-list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// govt officer job list

export async function getGovtOfficerJobsListApi(
  data: GetGovtOfficerJobListPayloadType
): Promise<AxiosResponse> {
  const { user_id, token } = data;
  let finalParams = {
    user_id,
  };

  return await getData(`finac-crm/govt-officer/jobs`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function signAuVerifyVoucherCodeApi(
  data: any
): Promise<AxiosResponse> {
  let csrfToken = localStorage.getItem("csrfToken");
  const finalData = {
    mobile_number: data?.mobileNumber,
    voucher_code: data?.voucherCode,
  };
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await postData(`verify/voucher-code`, finalData, {
    headers: {
      "content-Type": "application/json",
      "x-csrf-token": csrfToken,
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

export async function getPincodeApi(data: any): Promise<AxiosResponse> {
  const { pincode } = data;
  let finalParams = {
    pincode,
  };
  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );
  return await getData(`open-api/pincode/get/info`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

// payment gateway

export async function createOrder(data: any): Promise<AxiosResponse> {
  const { token } = data;

  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );

  let finalData = {
    ...data,
  };
  return await postData(`generate/order-id`, finalData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}

export async function verifyOrder(data: any): Promise<AxiosResponse> {
  let finalData = {
    ...data,
  };

  let userName = process.env.REACT_APP_USER_NAME_FOR_OPEN_API;
  let password = await convertPasswordToHash(
    process.env.REACT_APP_PASSWORD_OPEN_API
  );
  const base64Credentials = Buffer.from(`${userName}:${password}`).toString(
    "base64"
  );

  return await postData(`verify/payment`, finalData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${base64Credentials}`,
    },
  });
}
